import { Flex, GlobalToken } from "antd";
import styled from "styled-components";
import { Slider } from "@libertify/ui";
import { useAntTheme } from "hooks/useAntTheme";

export type DnaSliderEnd = {
  label: string;
  quote: string;
};

export type DnaSliderProps = Readonly<{
  /** 0–100 */
  value: number;
  low: DnaSliderEnd;
  high: DnaSliderEnd;
  onChange: (value: number) => void;
}>;

const TICKS = [0, 25, 50, 75, 100];

// Same layout as the onboarding slider steps: labelled ends, slider, tick marks.
export const DnaSlider = ({ value, low, high, onChange }: DnaSliderProps) => {
  const { theme } = useAntTheme();

  return (
    <Flex vertical gap={4}>
      <Flex justify="space-between" gap={16}>
        <StyledEnd $token={theme}>
          <b>{low.label}</b>
          <span>{low.quote}</span>
        </StyledEnd>
        <StyledEnd $token={theme} $end>
          <b>{high.label}</b>
          <span>{high.quote}</span>
        </StyledEnd>
      </Flex>

      <Slider
        min={0}
        max={100}
        value={value}
        onChange={onChange}
        tooltip={{ open: false }}
      />
      <Flex
        justify="space-between"
        style={{
          padding: "0 3px",
          fontSize: 10.5,
          color: theme.colorTextTertiary,
        }}
      >
        {TICKS.map((tick) => (
          <span key={tick}>|</span>
        ))}
      </Flex>
    </Flex>
  );
};

// ─── Styled components ───

const StyledEnd = styled.div<{ $token: GlobalToken; $end?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-width: 46%;
  text-align: ${({ $end }) => ($end ? "right" : "left")};

  b {
    font-size: 14px;
    color: ${({ $token }) => $token.colorText};
  }

  span {
    font-size: 12.5px;
    color: ${({ $token }) => $token.colorTextSecondary};
  }
`;
